export const MAX_RECENTLY_VIEWED_VEHICLES = 25;
